module.exports = __webpack_public_path__ + "static/4-795835a2f29dc1a1dcc39ef741e21a80.png";